export const VERIFY_EMAIL_ROUTE = '/auth/verify-email';
export const FORGOT_PASSWORD_ROUTE = '/auth/forgot-password';
export const RESET_PASSWORD_ROUTE = '/auth/reset-password';
export const MFA_ROUTE = '/auth/mfa';
export const POST_AUTH_ROUTE = '/auth/completing-sign-in';

export function buildVerifyEmailPath(options?: { redirect?: string | null, tenantId?: string | null }): string {
    const params = new URLSearchParams();
    const redirect = String(options?.redirect || '').trim();
    const tenantId = String(options?.tenantId || '').trim();

    if (redirect) {
        params.set('redirect', redirect);
    }

    if (tenantId) {
        params.set('tenantId', tenantId);
    }

    const query = params.toString();
    return query ? `${VERIFY_EMAIL_ROUTE}?${query}` : VERIFY_EMAIL_ROUTE;
}

export function isVerifyEmailPath(path: string): boolean {
    return path === VERIFY_EMAIL_ROUTE;
}

export function buildForgotPasswordPath(options?: { redirect?: string | null, tenantId?: string | null, email?: string | null }): string {
    const params = new URLSearchParams();
    const redirect = String(options?.redirect || '').trim();
    const tenantId = String(options?.tenantId || '').trim();
    const email = String(options?.email || '').trim();

    if (redirect) {
        params.set('redirect', redirect);
    }

    if (tenantId) {
        params.set('tenantId', tenantId);
    }

    if (email) {
        params.set('email', email);
    }

    const query = params.toString();
    return query ? `${FORGOT_PASSWORD_ROUTE}?${query}` : FORGOT_PASSWORD_ROUTE;
}

export function buildResetPasswordPath(options?: { redirect?: string | null, tenantId?: string | null }): string {
    const params = new URLSearchParams();
    const redirect = String(options?.redirect || '').trim();
    const tenantId = String(options?.tenantId || '').trim();

    if (redirect) {
        params.set('redirect', redirect);
    }

    if (tenantId) {
        params.set('tenantId', tenantId);
    }

    const query = params.toString();
    return query ? `${RESET_PASSWORD_ROUTE}?${query}` : RESET_PASSWORD_ROUTE;
}

export function buildMfaPath(options?: {
    redirect?: string | null,
    tenantId?: string | null,
    email?: string | null,
    source?: 'login' | 'client-login' | null,
}): string {
    const params = new URLSearchParams();
    const redirect = String(options?.redirect || '').trim();
    const tenantId = String(options?.tenantId || '').trim();
    const email = String(options?.email || '').trim();
    const source = String(options?.source || '').trim();

    if (redirect) {
        params.set('redirect', redirect);
    }

    if (tenantId) {
        params.set('tenantId', tenantId);
    }

    if (email) {
        params.set('email', email);
    }

    if (source) {
        params.set('source', source);
    }

    const query = params.toString();
    return query ? `${MFA_ROUTE}?${query}` : MFA_ROUTE;
}

export function buildPostAuthPath(options?: {
    redirect?: string | null,
    tenantId?: string | null,
    source?: 'login' | 'client-login' | null,
}): string {
    const params = new URLSearchParams();
    const redirect = String(options?.redirect || '').trim();
    const tenantId = String(options?.tenantId || '').trim();
    const source = String(options?.source || '').trim();

    if (redirect) {
        params.set('redirect', redirect);
    }

    if (tenantId) {
        params.set('tenantId', tenantId);
    }

    if (source) {
        params.set('source', source);
    }

    const query = params.toString();
    return query ? `${POST_AUTH_ROUTE}?${query}` : POST_AUTH_ROUTE;
}
